// extracted by mini-css-extract-plugin
export default {"r_l":"fee4836d8c _52e95ea20a","t":"_90b8fd19ab"};